import { PencilIcon, LockIcon, CheckIcon } from 'lucide-react'
import { CREATE_EDIT_WORKSPACE_STEPS } from '../workspace.constants'
import { Step } from '../../shared/types/riskWorkspace.types'
import { riskWorkspaceStepAtom } from '../../shared/state/riskWorkspace.atom'
import { useAtomValue } from 'jotai'

type WorkspacesCreateEditStepsProps = {
  currentStep: Step
  setCurrentStep: (step: Step) => void
}

type WorkspacesCreateEditStepProps = WorkspacesCreateEditStepsProps & {
  step: Step
}

type IconToShowProps = {
  completed: boolean
  active: boolean
}

const IconToShow = ({ completed, active }: IconToShowProps) => {
  if (completed) {
    return (
      <div className="bg-[#16a34a] border-2 border-[#16a34a] p-1 rounded-full text-white">
        <CheckIcon className="h-3 w-3" />
      </div>
    )
  }
  if (active) {
    return (
      <div className="border-2 border-rexTeal-200 bg-rexTeal-600 p-1 rounded-full text-white">
        <PencilIcon className="h-3 w-3" />
      </div>
    )
  }
  return (
    <div className="border-2 border-neutral-600 bg-neutral-300 p-1 rounded-full">
      <LockIcon className="h-3 w-3" />
    </div>
  )
}

const WorkspaceCreateEditStep = ({
  step,
  currentStep,
  setCurrentStep,
}: WorkspacesCreateEditStepProps) => {
  const workspaceSteps = useAtomValue(riskWorkspaceStepAtom)

  const onSelectNextStep = () => {
    setCurrentStep(step)
  }

  const completed = workspaceSteps[step]
  const active = currentStep === step

  return (
    <li
      className={`rounded-md flex p-4 gap-2 ${!completed && !active ? 'opacity-25 cursor-not-allowed' : 'cursor-pointer'} ${active && 'bg-[#f0f6ff]'} border-b`}
      onClick={onSelectNextStep}
    >
      <div>
        <IconToShow completed={completed} active={active} />
      </div>
      <p className="font-medium">{CREATE_EDIT_WORKSPACE_STEPS[step]}</p>
    </li>
  )
}

export const WorkspacesCreateEditSteps = ({
  currentStep,
  setCurrentStep,
}: WorkspacesCreateEditStepsProps) => {
  return (
    <div className="border-r h-[100vh] p-4">
      <ul>
        {Object.keys(CREATE_EDIT_WORKSPACE_STEPS).map((step, index) => {
          return (
            <WorkspaceCreateEditStep
              key={step + index}
              currentStep={currentStep}
              setCurrentStep={setCurrentStep}
              step={step as Step}
            />
          )
        })}
      </ul>
    </div>
  )
}
